<template>
  <div>
    <v-btn small color="success" class="mb-2" @click="sheet=true">Show Chart</v-btn>

    <v-bottom-sheet v-model="sheet" inset v-if="sheet">
      <v-sheet
        class="text-center"
        height="404px"
        width="660px"
        style="max-width: 660px; margin: 0 auto;"
      >
        <div>
          <highcharts :options="chartOptions"></highcharts>
        </div>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>
<script>
export default {
  props: {
    uniqProducts:{
        type: Array,
        default: ()=> []
        // default: function () {
        //   return ['ctrlKey', 'metaKey']
        // },
        // validator: function (value) {
        //   let allowedKeys = ['ctrlKey', 'metaKey', 'altKey'];
        //   let multiselectKeys = Array.isArray(value) ? value : [value];
        //   multiselectKeys = multiselectKeys.filter(keyName => allowedKeys.indexOf(keyName ) !== -1);
        //   return !!multiselectKeys.length;
        // }
    }
  },

//   components: {
//     highcharts: Chart
//   },
  watch: {
    uniqProducts: {
      handler: function(newValue) {
        this.setValues(newValue)    
      },
      deep: true
    }
  },
  mounted(){
    this.setValues(this.uniqProducts)
  },
  methods: {
    setValues(newValue){
      if (newValue.length > 0) {
        this.reset()
        for (var i = 0; i < newValue.length; i++) {
          this.chartOptions.xAxis.categories.push(newValue[i].month_name);
          this.chartOptions.series[0].data.push(parseInt(newValue[i].month_average_balance.toFixed(2)));
          this.chartOptions.series[1].data.push(parseInt(newValue[i].month_net_deposits.toFixed(2)));
        }
      }
    },
    reset(){
      this.chartOptions =  {
        chart: {
         type: "spline",
        },
        title: {
            text: 'Dollar'
        },
        responsive: {
          rules: [{
            condition: {
              maxWidth: 700,
            },
            chartOptions: {
              legend: {
                align: 'right',
                verticalAlign: 'top',
              }
            }
          }]
        },
        xAxis: {
          categories: []
        },
        tooltip: {
          crosshairs: true,
          shared: true
        },
        credits: {
          enabled: false
        },
        plotOptions: {
          spline: {
            marker: {
              radius: 4,
              lineColor: "#666666",
              lineWidth: 1
            }
          }
        },
        series: [
          {
            data: [],
            name: 'Average Balance'
          },{
            data: [],
            name: 'Net Deposits Balance'
          }
        ]
      }
    }
  },
  data() {
    return {
        sheet: false,
      chartdialog: false,
      editbankname: false,
      chartOptions: {
        chart: {
         type: "spline",
        },
        title: {
            text: 'Dollar'
        },
        responsive: {
          rules: [{
            condition: {
              maxWidth: 700,
            },
            chartOptions: {
              legend: {
                align: 'right',
                verticalAlign: 'top',
              }
            }
          }]
        },
        xAxis: {
          categories: []
        },
        tooltip: {
          crosshairs: true,
          shared: true
        },
        credits: {
          enabled: false
        },
        plotOptions: {
          spline: {
            marker: {
              radius: 4,
              lineColor: "#666666",
              lineWidth: 1
            }
          }
        },
        series: [
          {
            data: [],
            name: 'Average Balance'
          },{
            data: [],
            name: 'Net Deposits Balance'
          }
        ]
      }
    };
  }
};
</script>
 
<style >
.v-dialog {
  box-shadow: none !important;
}
</style>